<label>{{ 'reward.status.limit.reached' | translate }}</label>
